const $infoSchema     = $('.info-schema-svg');
const infoSchemaLinks = $infoSchema.find('.info-schema-svg__link');
const SCALE_CLASS     = 'is-scaled';
const ACTIVE_CLASS    = 'is-active';

export function infoSchemaEffects() {
  function changeLinePosition() {
    const link         = $infoSchema.find('.info-schema-svg__link.is-active');
    const activeLink   = $(link).data('name');
    const $linkLine    = $(`.${activeLink}__line`);
    const $lines       = (link.length) ? $('.line').not($linkLine) : $('.line');

    if ($(link).length) {
      [ ...$lines ].map((line) => {
        $(line).attr('filter', 'url(#blur)');
      });
    } else {
      [ ...$lines ].map((line) => {
        $(line).attr('filter', '');
      });
    }

    // const lineX   = $line.attr('x2');
    // const lineY   = $line.attr('y2');
    // const newLineX = +lineX + 30;
    // const newLineY = +lineY + 5;
    //
    // $line.attr('x2', newLineX);
    // $line.attr('y2', newLineY);
    // console.log(newLineX, newLineY);
  }

  $('.info-schema-svg__link').on('mouseenter', function () {
    const backLinks = $('.info-schema-svg__link').not(this);

    $(this).addClass(ACTIVE_CLASS);
    [ ...backLinks ].map((link) => {
      $(link).addClass(SCALE_CLASS);
      $(link).attr('filter', 'url(#blur)');
    });
    changeLinePosition();

    $(this).on('mouseleave', function () {
      $(this).removeClass(ACTIVE_CLASS);
      [ ...infoSchemaLinks ].map((link) => {
        $(link).removeClass(SCALE_CLASS);
        $(link).attr('filter', '');
      });
      changeLinePosition();
    });
  });
}



// WEBPACK FOOTER //
// ./js/schema-old.js